import React from 'react'

import Lottie from '../Lottie/Lottie'

const Landing = () => {
  return (
    <div
      style={{
        width: '100vw',
        textAlign: 'center',
        height: '100vh',
      }}
    >
      <Lottie />
    </div>
  )
}

export default Landing
